import api from '../../utils/api';

const assistantService = {
  getAssistants: async () => {
    const response = await api.get('/partners/assistants');
    return response.data;
  },

  getAssistant: async (id) => {
    const response = await api.get(`/partners/assistants/${id}`);
    return response.data;
  },

  createAssistant: async (data) => {
    const response = await api.post('/partners/assistants', { assistant: data });
    return response.data;
  },

  quickCreateAssistant: async (data) => {
    const response = await api.post('/partners/assistants/quick_create', { assistant: data });
    return response.data;
  },

  updateAssistant: async (id, data) => {
    const response = await api.patch(`/partners/assistants/${id}`, { assistant: data });
    return response.data;
  },

  deleteAssistant: async (id) => {
    const response = await api.delete(`/partners/assistants/${id}`);
    return response.data;
  },
};

export default assistantService;
